const STEPS = [
  { n: '01', title: 'Create Your Profile',      desc: 'Set up your football identity—position, stats, highlights. 2 minutes max.' },
  { n: '02', title: 'Create or Find a Game',    desc: 'Post a game in 30 seconds or browse games near you right now.' },
  { n: '03', title: 'Share One Link',           desc: 'Everyone sees who\'s confirmed. No back-and-forth, no confusion.' },
  { n: '04', title: 'Play & Build Reputation',  desc: 'Challenge friends. Track stats. Get noticed by scouts.' },
];

export default function HowItWorks() {
  return (
    <section style={{ padding: '7rem clamp(1rem,4vw,3rem)' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div className="vis" style={{ marginBottom: '4rem' }}>
          <span className="section-tag">HOW IT WORKS</span>
          <h2 className="section-title" style={{ fontSize: 'clamp(36px,5vw,56px)' }}>
            Four Steps to<br /><span>Your Next Game.</span>
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '2rem' }}>
          {STEPS.map((s, i) => (
            <div key={i} className="vis" style={{ position: 'relative' }}>
              {/* Connector arrow */}
              {i < STEPS.length - 1 && (
                <div style={{
                  position: 'absolute', top: 28, left: 'calc(100% - 1rem)', right: '-1rem',
                  height: 1, background: 'linear-gradient(90deg,var(--coral),transparent)', zIndex: 1,
                }} />
              )}
              {/* Step number badge */}
              <div style={{
                width: 56, height: 56, borderRadius: 8,
                background: 'rgba(232,96,74,0.1)',
                border: '1px solid rgba(232,96,74,0.2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontFamily: 'var(--font-d)', fontSize: 22, fontWeight: 900, color: 'var(--coral)',
                marginBottom: '1.5rem', position: 'relative', zIndex: 2,
              }}>{s.n}</div>
              <h3 style={{
                fontFamily: 'var(--font-d)', fontSize: 20, fontWeight: 800,
                textTransform: 'uppercase', letterSpacing: 1, marginBottom: '0.75rem',
              }}>{s.title}</h3>
              <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.75 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
